<tt-page class="col-xs-12 col-md-4 sp-0" *ngIf="!!setting">
    <tt-card>
        <form class="form-horizontal sp-0" name="formSelectTextileModel" novalidate (ngSubmit)="searchItems()" method="get" role="form">
            <tt-input ttLabel="searchtext" ttFocus="true" [(ttModel)]="setting.searchtext" (ttModelChange)="onChanged($event, 'searchtext')" ttShowClearButton [ttButtons]="searchTextButtons"></tt-input>
        </form>
    </tt-card>

    <tt-list [ttData]="itemsListModels"></tt-list>
</tt-page>
